import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollProgress from "./ScrollProgress";
import FloatingCTAs from "./FloatingCTAs";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollProgress />
      <Header />
      {/* Spacer to compensate for fixed header.
          Mobile (<md): 68px (logo row only — utility bar is hidden md:block)
          Desktop (md+): 36px (utility bar h-9) + 80px (md:h-20) = 116px */}
      <main className="flex-1 page-fade-in pt-[68px] md:pt-[116px]">{children}</main>
      <Footer />
      <FloatingCTAs />
    </div>
  );
}
